import React from "react"

export const CheckMarkNoOutline = ({ color }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.15137 18.3612C1.54388 16.9162 2.86887 15.28 5.15873 15.76C6.96871 16.2812 8.45857 17.8937 9.64737 20.5299C16.311 11.2723 22.041 4.90237 29.6074 2.51229C30.2824 2.35479 30.6374 2.39229 30.1449 2.94979C22.326 9.26851 15.2562 18.4336 9.76247 29.8272C9.63372 30.0935 9.17498 30.0735 9.02122 29.7835C7.34247 26.736 6.14871 23.7636 4.46986 20.716C3.72113 19.1397 2.77236 18.0059 1.15242 18.3597L1.15137 18.3612Z"
      fill={color ?? "#000"}
    />
  </svg>
)

const CheckMark = ({ color }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C3.58144 0 0 3.58164 0 8C0 12.4184 3.58164 16 8 16C12.4184 16 16 12.4184 16 8C16 3.58164 12.4184 0 8 0ZM8 1.23077C11.7323 1.23077 14.7692 4.26772 14.7692 8C14.7692 11.7323 11.7323 14.7692 8 14.7692C4.26772 14.7692 1.23077 11.7323 1.23077 8C1.23077 4.26772 4.26772 1.23077 8 1.23077Z"
      fill={color ?? "#000"}
    />
    <path
      d="M6.69461 11.0471L6.69538 11.0479L11.9207 5.82329L11.05 4.95251L6.69461 9.30786L4.94999 7.56324L4.07999 8.43325L6.69375 11.047L6.69452 11.0462L6.69461 11.0471Z"
      fill={color ?? "#000"}
    />
  </svg>
)

export default CheckMark
